import React, { Fragment } from "react";
import { selectFormat, truncate } from "../Utils.js";
import { XRayTooltipHeader } from "./../XrayUtils.js";

export const XRayTooltipContentVelocity = (props) => {
  const { data, close } = props;
  const payload = data.activePayload;

  if (payload && payload.length > 0) {
    const tooltip_data = payload.splice(3);
    const content_data = data.content_data;

    const date =
      tooltip_data[0].payload.label + tooltip_data[0].payload.label === 1
        ? "h"
        : "hrs";
    return (
      <div className="xray-tooltip">
        <XRayTooltipHeader date={date} close={close} />
        <main className="standard-tooltip__main">
          {Object.keys(tooltip_data)
            .sort((a, b) => tooltip_data[b].value - tooltip_data[a].value)
            .map((key, index) => {
              return (
                <Fragment key={key}>
                  {tooltip_data[key].value >= 0 && (
                    <div className="standard-tooltip__item">
                      <span
                        className="standard-tooltip__key"
                        style={{
                          color: tooltip_data[key].color,
                          textTransform: "none",
                        }}
                      >
                        <span
                          className="standard-tooltip__icon"
                          style={{ background: tooltip_data[key].color }}
                        />
                        {truncate(content_data[key].title, 25)}
                      </span>
                      <span className="standard-tooltip__value">
                        {selectFormat("number", tooltip_data[key].value)}
                      </span>
                    </div>
                  )}
                </Fragment>
              );
            })}
        </main>
      </div>
    );
  }

  return null;
};
